import styled from 'styled-components';
import { Link } from 'react-router-dom';

type NavLinkProps = {
  isActive: boolean;
};

export const NavContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48px;
  color: black;
  gap: 40px;
  @media (max-width: 700px) {
    margin-left: 20px;
    justify-content: start;
  }
  @media (max-width: 600px) {
    display: none;
  }
`;

export const NavLink = styled(Link)<NavLinkProps>`
  color: black;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: 900;
  transition:
    color 0.1s ease,
    transform 0.1s ease;

  &:hover {
    color: black;
    text-decoration: underline;
  }
  &:focus {
    color: #af9483;
    text-decoration: underline;
  }
  color: ${(props) => props.isActive && 'color: #af9483'};
  text-decoration: ${(props) => props.isActive && 'underline'};
`;

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    height: 14px;
    background: transparent;
    z-index: 999;
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border: none;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  min-width: 160px;
  z-index: 1000;
  margin-top: 8px;
  padding: 8px 0;
  animation: slideDown 0.15s ease-out;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid white;
  }
`;

export const DropdownItem = styled.div`
  padding: 12px 20px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  color: #424242;
  transition: all 0.15s ease;
  text-transform: none;

  &:hover {
    background-color: #f5f5f5;
    color: #af9483;
  }

  &:active {
    background-color: #eeeeee;
  }
`;
